"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WktFeatureLoader = void 0;
var olExtent = require("ol/extent");
var WKT_1 = require("ol/format/WKT");
var WktFeatureLoader = /** @class */ (function () {
    function WktFeatureLoader() {
        this.load = function (layerSource, featureAdd, data, dataProjection, displayProjection, resolution, logger, wktProperty) {
            //remove existing features
            var features = layerSource.source.getFeatures();
            features.forEach(function (feature) {
                layerSource.source.removeFeature(feature);
            });
            var format = new WKT_1.default();
            var dataBounds = olExtent.createEmpty();
            //single record
            if (data[wktProperty]) {
                data = [data];
            }
            for (var i = 0; i < data.length; i++) {
                try {
                    var feature = format.readFeature(data[i][wktProperty], {
                        dataProjection: dataProjection,
                        featureProjection: displayProjection
                    }); //parse WKT
                    dataBounds = olExtent.extend(dataBounds, feature.getGeometry().getExtent());
                    feature.setProperties(data[i], true);
                    feature.setId(data[i].uid);
                    featureAdd.addFeature(layerSource, feature, resolution);
                }
                catch (ex) {
                    logger.error(ex.message + ", " + ex.stack);
                    logger.error(JSON.stringify(data[i]));
                }
            }
            return dataBounds;
        };
    }
    return WktFeatureLoader;
}());
exports.WktFeatureLoader = WktFeatureLoader;
//# sourceMappingURL=WktFeatureLoader.js.map